import { useNavigate } from 'react-router';
import { analytics } from '../services/analytics';

export const useBreadcrumbNavigation = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  const goToStore = () => {
    navigate('/');
  };

  const goToCart = () => {
    navigate('/cart');
  };

  const goToWishlist = () => {
    navigate('/wishlist');
  };

  const goToOrders = () => {
    navigate('/orders');
  };

  const goToLandingPage = async() => {
    if ((window as any).flutterChannel) {
      (window as any).flutterChannel.postMessage('navigateToLanding');
    } else {
      window.location.href = '/';
    }
  };

  const goToLogin = () => {
    // Login handoff from an in-page CTA (add-to-cart/buy while logged out) —
    // the SDK's __path property identifies the page.
    analytics.track('login_link_clicked', { source: 'store_page' });
    if ((window as any).flutterChannel) {
      (window as any).flutterChannel.postMessage('navigateToSignIn');
    } else {
      console.error('flutterChannel is not defined.');
      const loginUrl = process.env.REACT_APP_LOGIN_URL;
      if (loginUrl) {
        window.location.href = loginUrl + '?redirectUrl=' + window.location.href;
      } else {
        console.error('Login page URL is not defined');
      }
    }
  };

  const goToNotificationPage = () => {
    if ((window as any).flutterChannel) {
      (window as any).flutterChannel.postMessage('navigateToNotifications');
    } else {
      console.error('flutterChannel is not defined.');
      const notificationUrl = process.env.REACT_APP_HOME_URL + '/notifications';
      if (notificationUrl) {
        window.location.href = notificationUrl;
      } else {
        console.error('notificationUrl URL is not defined');
      }
    }
  };

  const goToSubscriptionPage = () => {
    const subscriptionUrl = process.env.REACT_APP_SUBSCRIPTION_PAGE_URL;
    if (subscriptionUrl) {
      window.location.href = subscriptionUrl;
    } else {
      console.error('Subscription page URL is not defined');
    }
  };

  return {
    goToHome,
    goToStore,
    goToCart,
    goToWishlist,
    goToOrders,
    goToLogin,
    goToNotificationPage,
    goToSubscriptionPage
  };
}; 